import React from "react";
import { useNavigate } from "react-router-dom";

import loginNavigation from '../../../../assets/icons/login-navigation.svg'

const Agreement = () => {
    const navigate = useNavigate();

    return (
        <>
            <div onClick={() => navigate(-1)}>
                <img src={loginNavigation}/>
            </div>
        </>
    )
}

export default Agreement;